import { useState } from "react";
import { fetchStreaming, getLogsStreaming, getPathsFromStream, getStreamingStatus } from "../services/API/CardComponentApi";
import { useQuery } from "react-query";

const useCardComponent = () => {
    const [listStreaming, setListStreaming] = useState([]);
    const [enabledStreaming, setEnabledStreaming] = useState(false);
    const [dashboard, setDasboard] = useState('');
    const [token, setToken] = useState('');


    const [typeOfStream, setTypeOfStream] = useState(''); // Configura este valor según sea necesario
    const [wellName, setWellName] = useState(''); // Estado actual del wellName


    const { isLoading, isError } = useQuery(
        ['streaming_list', dashboard, token],
        () => fetchStreaming(dashboard, token),
        {
            enabled: enabledStreaming,
            retry: 2,
            onError: () => {
                console.log("Error");
            },
            onSuccess: (data) => {
                setEnabledStreaming(false)
                // setListStreaming(data.stream_types);
            }
        }
    );

    const refetchPathFromStream = async ({ product, client, project, type, well }) => {
        const result = await getPathsFromStream(product, client, project, type, well);
        return result; 
    };

    const triggerGetStreamingStatus = async ({product, client, project, type, well }) => {
        const result = await getStreamingStatus(product, client, project, type, well);
        return result; 
    }

    const triggerGetLogsStreaming = async(product, client, streamType, project, wellName, logType) => {
        const result = await getLogsStreaming(product, client, streamType, project,wellName,logType);
        return result;
    }

    return {
        setToken,
        setDasboard,
        isLoading,
        isError,
        setEnabledStreaming,
        setWellName,
        refetchPathFromStream,
        setTypeOfStream,
        triggerGetStreamingStatus,
        triggerGetLogsStreaming
    }
}

export { useCardComponent };